'use client';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';

interface SocialMediaSectionProps {
  className?: string;
}

export default function SocialMediaSection({ className = '' }: SocialMediaSectionProps) {
  return (
    <section className={`w-full flex justify-center items-center ${className}`}>
      <div className="flex gap-[15px] sm:gap-[18px] md:gap-[20px] justify-center items-start">
        <Link href="#" className="transition-transform hover:scale-110">
          <FontAwesomeIcon
            icon={faInstagram}
            className="w-[36px] sm:w-[42px] md:w-[48px] h-[36px] sm:h-[42px] md:h-[48px]"
            style={{ color: 'var(--text-primary)' }}
          />
        </Link>
        <Link href="#" className="transition-transform hover:scale-110">
          <FontAwesomeIcon
            icon={faFacebook}
            className="w-[36px] sm:w-[42px] md:w-[48px] h-[36px] sm:h-[42px] md:h-[48px]"
            style={{ color: 'var(--text-primary)' }}
          />
        </Link>
      </div>
    </section>
  );
}